import { Box, Typography, FormGroup, Button, Grid } from "@mui/material";
import { useVerification } from "../context/Verification.context";
import { useQuery } from "@apollo/client";
import { FETCH_QUESTIONNAIRE } from "../graphql/query/query";
import { BulletListShimmer } from "react-content-shimmer";
import Lottie from "react-lottie";
import NoVehicle from "../assets/gifs/no-vehicle.json";
import { lottieLoopOptions, TYPE } from "./Utils";
import AppButton from "../component/base/AppButton.component";
import { useNavigate } from "react-router-dom";
import QuoteQuestionsComponent from "../component/app/verification/QuoteQuestions.component";
import HocPopup from "../hoc/hocPopup";
import Theme from "./Theme";
import { navigateAfterQuote } from "./videoPlayer";

const TradeAndQuoteComponent = ({
  artifact,
  handleClose,
  videoUrl,
  isAITrade = false,
  isAIQuote = false,
  dialog,
  loading,
  tradeVehicleIds,
  setTradeVehicleIds,
  tradeVehicles,
  getVehicleDetails,
  onInteraction,
}) => {
  const verification = useVerification();
  const navigate = useNavigate();

  lottieLoopOptions.animationData = NoVehicle;

  const { data: fetchQuestionnaire } = useQuery(FETCH_QUESTIONNAIRE, {
    variables: {
      questionnaireInput: {
        dealership_id: parseInt(verification.dealershipId),
      },
    },
  });

  let getPercentage = verification?.percentage;
  let getPremium = verification?.customer?.totalPremiumCents;

  let percentageCalculation = ((getPercentage / 100) * getPremium) / 12;
  percentageCalculation = Math.round(percentageCalculation);

  console.log("trade1111", artifact);

  const enOptions = JSON.parse(artifact?.quote_options || "[]");
  const esOptions = JSON.parse(artifact?.es_quote_options || "[]");
  const displayOptions = verification.aiData.spanish ? esOptions : enOptions;
  return (
    <>
      {isAITrade && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
            // gap: "20px",
            // flex: 1,
            justifyContent: "center",
          }}
        >
          {!loading && tradeVehicles.length > 0 ? (
            <Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  overflow: "auto",
                }}
              >
                <FormGroup>
                  <Grid container spacing={2}>
                    {tradeVehicles.map((vehicle) => {
                      const isSelected = tradeVehicleIds.includes(
                        parseInt(vehicle.vehicle_id),
                      );

                      return (
                        <Grid item xs={12} sm={6} key={vehicle.vehicle_id}>
                          <Button
                            fullWidth
                            variant={isSelected ? "contained" : "outlined"}
                            color="primary"
                            sx={{
                              justifyContent: "center",
                              alignItems: "center",
                              borderRadius: "8px",
                              bgcolor: isSelected ? "primary.main" : "white", // ← Explicit colors
                              touchAction: "manipulation",
                              "&.MuiButton-outlined": {
                                backgroundColor: "white", // ← Force white background for outlined
                              },
                              "&.MuiButton-contained": {
                                backgroundColor: "primary.main", // ← Force primary background for contained
                              },
                            }}
                            onClick={() => {
                              onInteraction?.();
                              if (isSelected) {
                                setTradeVehicleIds(
                                  tradeVehicleIds.filter(
                                    (id) => id !== parseInt(vehicle.vehicle_id),
                                  ),
                                );
                              } else {
                                setTradeVehicleIds([
                                  ...tradeVehicleIds,
                                  parseInt(vehicle.vehicle_id),
                                ]);
                              }
                            }}
                          >
                            <Box
                              sx={{ display: "flex", flexDirection: "column" }}
                            >
                              <Typography sx={{ fontWeight: "bold" }}>
                                {getVehicleDetails(vehicle)}
                              </Typography>
                              <Typography variant="body2">
                                {vehicle.vin ? vehicle.vin : "N/A"}
                              </Typography>
                            </Box>
                          </Button>
                        </Grid>
                      );
                    })}

                    {/* No Vehicle button - aligned in grid */}
                    <Grid item xs={12} sm={6}>
                      <Button
                        fullWidth
                        variant={
                          tradeVehicleIds.length === 0
                            ? "contained"
                            : "outlined"
                        }
                        color="primary"
                        sx={{
                          borderRadius: "8px",
                          height: "55px",
                          bgcolor:
                            tradeVehicleIds.length === 0
                              ? "primary.main"
                              : "white", // ← Explicit colors
                          touchAction: "manipulation",
                          "&.MuiButton-outlined": {
                            backgroundColor: "white",
                          },
                          "&.MuiButton-contained": {
                            backgroundColor: "primary.main",
                          },
                        }}
                        onClick={() => {
                          onInteraction?.();
                          setTradeVehicleIds([]);
                        }}
                      >
                        {!verification?.aiData?.spanish
                          ? "No Vehicle being traded"
                          : "No se intercambia ningún vehículo."}
                      </Button>
                    </Grid>
                  </Grid>
                </FormGroup>
              </Box>
            </Box>
          ) : !loading && tradeVehicles.length <= 0 ? (
            <Box
            // sx={{
            //   width: "100%",
            //   padding: "48px",
            //   display: "flex",
            //   flexDirection: "column",
            //   alignItems: "center",
            //   gap: "8px",
            // }}
            >
              <Lottie
                options={lottieLoopOptions}
                height={
                  window.innerHeight >= 1440
                    ? 360
                    : window.innerHeight >= 1050
                      ? 360
                      : window.innerHeight >= 900
                        ? 300
                        : 200
                }
                width={
                  window.innerHeight >= 1440
                    ? 360
                    : window.innerHeight >= 1050
                      ? 360
                      : window.innerHeight >= 900
                        ? 300
                        : 200
                }
              />
              <Typography variant="h5">No vehicles found to trade</Typography>
            </Box>
          ) : (
            <BulletListShimmer
              size={{
                height: window.innerWidth <= 750 ? 140 : 200,
                width: window.innerWidth <= 750 ? 30 : 50,
              }}
            />
          )}
        </Box>
      )}
      {isAIQuote && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {verification.customer.premium && parseInt(getPercentage) > 1 && (
            <AppButton
              buttonText={
                !verification?.aiData?.spanish
                  ? `Possible Savings: $${percentageCalculation}/month`
                  : `Posibles ahorros: $${percentageCalculation}/mes`
              }
              size="large"
              variant="outlined"
              sx={{
                width: window.innerWidth <= 750 ? "80%" : "50%",
                color: "primary",
                borderColor: "Theme.palette.primary.main",
                bgcolor: "white",
                mb: 8,
              }}
              disabled={loading}
            />
          )}

          <AppButton
            buttonText={displayOptions?.[0] || "Yes save me money"}
            size="large"
            variant="contained"
            sx={{ width: window.innerWidth <= 750 ? "80%" : "50%" }}
            clickHandler={() => {
              dialog({
                open: true,
                bodyType: TYPE.QUOTE_QUESTIONS,
                body: (
                  <QuoteQuestionsComponent
                    fetchQuestionnaire={fetchQuestionnaire}
                    loading={loading}
                    isAIQuote={isAIQuote}
                    artifact={artifact}
                  />
                ),
                maxWidth: "md",
                fullScreen: true,
              });
            }}
            disabled={loading}
          />

          <AppButton
            buttonText={displayOptions?.[1] || "Maybe later"}
            size="large"
            variant="outlined"
            sx={{
              width: window.innerWidth <= 750 ? "80%" : "50%",
              color: "#808080",
              borderColor: "#808080",
             bgcolor: "white !important",
              "&:hover": {
                 bgcolor: "white !important",
                //  color:Theme.palette.primary.main + "!important",
              },
            }}
            clickHandler={() => {
              navigateAfterQuote(navigate, verification);
            }}
            disabled={loading}
          />
        </Box>
      )}
    </>
  );
};

export default HocPopup(TradeAndQuoteComponent);
